import React, {useEffect} from 'react';
import Home_page from '../Component/Home_page'
import Main_Brand_slider from '../Component/Main_Brand_slider'
import Seconde_Component from '../Component/Seconde_Component'
import Third_Component from '../Component/Third_Component'
import Total_Count from '../Component/Total_Count'
import Contact_Component from '../Component/Contact_Component'
import Review_Component from '../Component/Review_Component'
import Zoom from 'react-reveal/Zoom';
import Collabration from './Collabration'
import Certified_comp from '../Component/Certified_comp';
import { Helmet } from 'react-helmet-async';
import Trending_blog_comp from '../Component/Trending_blog_comp';
import Success_Stats from '../Component/Success_Stats';
import Popular_cource from '../Component/Popular_cource';

function Main_Home_page() {
  const canonicalUrl = 'https://www.internselite.net/';
  return (
    <div>
      <Helmet>
      <title>InternsElite: Premier Online Courses & Internships from Industry Experts</title>
        <meta name='description' content='InternsElite offers the best online courses and internships for students and professionals. Enhance your skills with our certification courses, virtual internships, and expert-led training programs in fields like machine learning, web development, digital marketing, and more. Join InternsElite to kickstart your career with industry-recognized certifications and hands-on experience' />
        <meta name='keywords' content='online internship, professional courses, certification course, online training, virtual internship, best online courses' />
        <meta property="og:title" content="InternsElite: Premier Online Courses & Internships from Industry Experts" />
        <meta property="og:description" content="InternsElite offers the best online courses and internships for students and professionals. Enhance your skills with our certification courses, virtual internships, and expert-led training programs in fields like machine learning, web development, digital marketing, and more. Join InternsElite to kickstart your career with industry-recognized certifications and hands-on experience" />
        <meta property="og:url" content="https://internselite.net/" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@internselite" />
        <meta name="twitter:title" content="InternsElite: Premier Online Courses & Internships from Industry Experts" />
        <meta name="twitter:description" content="InternsElite offers the best online courses and internships for students and professionals. Enhance your skills with our certification courses, virtual internships, and expert-led training programs in fields like machine learning, web development, digital marketing, and more. Join InternsElite to kickstart your career with industry-recognized certifications and hands-on experience" />
        <meta name="twitter:image" content="https://internselite.net/static/media/logo.c1eb8ff81ef75599f376.png" />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      <Home_page/>
      <Zoom><Main_Brand_slider/></Zoom>
      <Certified_comp/>

      <Seconde_Component/>
      <Collabration/>
      <Popular_cource/>
      <Third_Component/>
      <Total_Count/>
      
      {/* <Success_Stats/> */}
      
      
      {/* <Trending_blog_comp/> */}
      <Review_Component/>
      <Contact_Component/>
    </div>
  )
}

export default Main_Home_page
